import { useCallback } from "react";
import { SnackbarProps } from "../components/Snackbar";
import {
  SnackbarActionType,
  useSnackBarContext,
} from "../context/SnackbarContext";

export function useSnackbar(props?: SnackbarProps) {
  const [state, dispatch] = useSnackBarContext();
  return useCallback(
    (properties: SnackbarProps) => {
      dispatch({
        type: SnackbarActionType.OPEN_SNACKBAR,
        payload: {
          ...props,
          ...properties,
        },
      });
    },
    [props, dispatch],
  );
}
